module.exports = __webpack_public_path__ + "static/media/SelfAwarenessOfValues.451725c1.mp3";